$(function() {
    "use strict";

    $(document).on("click.droppable-pane", ".droppable-pane__toggle", function(event) {
        event.preventDefault();
        var parent      = $(this).parents('.droppable-pane'),
            popupId     = parent.attr('popup-id'),
            shownClass  = 'droppable-pane_shown',
            data        = {};

        parent.toggleClass(shownClass);
        if (parent.hasClass(shownClass)) { data.state = 'shown'; }
        $.post('/up/' + popupId + '/', data);
    });

});